<template>
  <v-list-item
    :href="
      item.openInNewTab
        ? item.to
          ? $router.resolve(item.to).href
          : item.href
        : href
    "
    :rel="
      item.openInNewTab
        ? 'noopener'
        : href && href !== '#'
        ? 'noopener'
        : undefined
    "
    :target="
      item.openInNewTab ? '_blank' : href && href !== '#' ? '_blank' : undefined
    "
    :to="!item.openInNewTab && !item.lastVisited ? item.to : undefined"
    :active-class="``"
    @click="handleClick"
  >
    <v-list-item-icon v-if="item.icon">
      <v-icon v-text="item.icon" />
    </v-list-item-icon>

    <v-list-item-content v-if="item.title">
      <v-list-item-title v-text="item.title" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "BaseItem",

  mixins: [Themeable],

  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
  },

  methods: {
    handleClick() {
      if (!this.item.lastVisited) return;

      const { key } = this.item.lastVisited;
      const lastVisited = this.$store.getters["lastVisited/getLastVisited"](key);

      // Already on a detail page of this module: behave like "Back to list"
      if (lastVisited?.route?.name === this.$route.name) {
        this.$store.dispatch("lastVisited/clearLastVisited", key);
        this.$router.push(this.item.to).catch(() => {});
      } else if (lastVisited && lastVisited.route) {
        this.$router.push(lastVisited.route).catch(() => {});
      } else {
        this.$router.push(this.item.to).catch(() => {});
      }
    },
  },
};
</script>
